import React from 'react';
import {images} from '../../constants';
import SubHeading from '../../components/SubHeading/SubHeading';

const FindUs = () => (
  <div className=' app__wrapper section__padding flex__center app__bg' id="contact">
    <div className='app__wrapper_info'>
        <SubHeading title="Contact"/>
        <h1 className='headtext__cormorant' style={{ marginBottom: '3rem'}}>Find Us</h1>
        <div className='app__wrapper-content'>
        <p className='p__opensans'>Lorem ipsum dolor sit amet consectetur, adipisicing elit. Inventore saepe unde possimus aspernatur fuga doloribus?</p>
        <p className='p__cormorant' style={{ color: '#DCCA87', margin: '2rem 0rem'}}>Opening Hours</p>
        <p className='p__opensans'>Mon - Fri: 10:00 am - 02:00 am</p>
        <p className='p__opensans'>Sat - Sun: 10:00 am - 03:00 am</p>

        </div>
        <button className='custom__button'style={{marginTop: '2rem'}}>View Us</button>

    </div>

    <div className='app__wrapper_img'>
        <img src={images.findus} alt="findus"/>
    </div>
  </div>
);

export default FindUs;
